import locales from "./locales/locales";
import router from './routes/routes'

export const RatesModule = {
	name: 'rates',
	routes: router,
	locales: locales,
}